(function () {
  angular
    .module("akitabox.ui.dialogs.assetCondition")
    .factory("AssetConditionDialog", AssetConditionDialog);

  /* @ngInject */
  function AssetConditionDialog($mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/asset-condition/asset-condition.dialog.html",
      controller: "AssetConditionDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      escapeToClose: false,
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    /**
     * AssetConditionDialog service
     *
     * @type {Object}
     */
    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog
     *
     * @param {Object}          options                   Dialog options
     * @param {Object}          options.locals            Locals scope variables
     * @param {Object}          options.locals.buildingId Building the model is in
     * @param {Object}          options.locals.assetId    Asset the model is in
     * @param {Function}        options.locals.update     The (optional) update function to call
     *
     * @return {Promise<Object|Error>}       Promise that resolves with the newly created floor
     */
    function show(options) {
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
